import React, { Fragment, useContext } from "react";

import { ThemeProvider } from "@material-ui/core/styles";
import AppContext from "app/appContext";
import Footer from "app/MatxLayout/SharedCompoents/Footer";
import Layout2Topbar from "app/MatxLayout/Layout2/Layout2Topbar";
import Scrollbar from "react-perfect-scrollbar";
import { useTheme } from "@material-ui/styles";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { layout2Styles } from "app/MatxLayout/Layout2/_layout2";

const AeoIntroduce = ({children}) => {
    // import layout2 styels
    layout2Styles();
  
    const theme = useTheme();
    const { routes } = useContext(AppContext);
    const { settings } = useSelector(({ layout }) => layout);
  
    let { layout2Settings } = settings;
    let topbarTheme = settings.themes[layout2Settings.topbar.theme];
    let navbarTheme = settings.themes[layout2Settings.navbar.theme];
    const {
      leftSidebar: { mode: sidenavMode, show: showSidenav },
    } = layout2Settings;
  
    let layoutClasses = {
      [settings.activeLayout]: true,
      "bg-default text-primary": true,
      [`sidenav-${layout2Settings.leftSidebar.mode}`]: true,
      [`layout-${layout2Settings.mode} theme-${theme.palette.type}`]: true,
    };
  
    return (
      <Fragment>
        <div
          className={clsx(
            layoutClasses,
            "flex-grow flex-column relative overflow-hidden h-full-screen"
          )}
        >
          {layout2Settings.topbar.show && (
            <ThemeProvider theme={topbarTheme}>
                <Layout2Topbar />
            </ThemeProvider>
          )}
          <div style={{overflowY:"auto"}}>
          {children}
          </div>
          { settings.perfectScrollbar && (
            <Scrollbar
              options={{ suppressScrollX: true }}
              className="flex-column flex-grow relative"
            >
              <div className="flex-grow relative p-0"></div>
              {settings.footer.show && !settings.footer.fixed && <Footer />}
            </Scrollbar>
          )}
  
          {  !settings.perfectScrollbar && (
            <div
              options={{ suppressScrollX: true }}
              className="flex-column flex-grow relative scroll-y p-0"
            >
              <div className="flex-grow relative p-0"></div>
              {settings.footer.show && !settings.footer.fixed && <Footer />}
            </div>
          )}
  
          {settings.footer.show && settings.footer.fixed && <Footer />}
        </div>
      </Fragment>
    );
  };

export default AeoIntroduce;
